import React from 'react';
// Components
import AboutInfoContainer from './AboutInfoContainer';
import ScrollingWords from '../general/ScrollingWords';
import SocialMediaCtaComponent from '../socialMedia/SocialMediaCtaComponent';
import AboutInfoContainer2 from './AboutInfoContainer2';
import HomePageAboutSection from '../home/HomePageAboutSection';

function AboutPageMainContainer() {
  return (
    <main role='main' className='grid w-full h-full overflow-hidden'>
      {/* Container */}
      {/* About Me */}
      <HomePageAboutSection />

      <AboutInfoContainer />

      {/* Scrolling text */}
      <ScrollingWords />

      {/* Container */}
      <AboutInfoContainer2 />
      <section className='bg-colour4 text-colour1 dark:text-colour1 px-6 py-6 lg:py-12 sm:px-10 md:px-16 lg:px-24 text-center italic font-light'>
        <p className='text-lg sm:text-xl md:text-lg leading-relaxed max-w-4xl mx-auto font-argesta'>
          “I was{' '}
          <span className='font-semibold'>YOURS</span>. From start to finish, it
          was an awesome experience! If this was not enough, I found{' '}
          <span className='font-semibold'>YOU</span> to be extremely attractive,
          professional, and clearly enjoying everything you did to me. (Seriously, I wish I could play every day!)

          <br />
          <span className='not-italic font-medium block mt-4'>
            10/10 – Playful slave Rick, April 2025
          </span>
        </p>
      </section>

      {/* Social */}
      <SocialMediaCtaComponent />
    </main>
  );
}

export default AboutPageMainContainer;
